'use strict';

angular.module('amexReconciliationApp')
  .component('paginationDisplay', {
    templateUrl: 'scripts/views/components/pagination-display.html',
    controller: function (TransactionPaginationService) {
      
      var self = this;

      self.$onInit = function() {
        self.pageStart = TransactionPaginationService.pageStart;
        self.pageEnd = TransactionPaginationService.pageEnd;
        self.totalCount = TransactionPaginationService.totalCount;
      };

    }
  });
      
      
      
      
      
      
    


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/paginationDisplay.js
// module id = 463
// module chunks = 0